/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, June 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import RodoContent from '../../components/RodoContent/RodoContent';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import MapToPDF from '../../components/MapToPDF';
import { connect } from 'react-redux';
import { runService, saveValidators } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import agentConfig from './agent';
import loadingData from './loading';

import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  // AddressFlat: {
  //   label: 'Numer lokalu',
  //   editable: true,
  // },
  // AddressNumber: {
  //   label: 'Numer budynku',
  //   editable: true,
  // },
  // AddressZipCode: {
  //   label: 'Kod pocztowy',
  //   editable: true,
  // },
};

const agentDict = {
  agentName: {
    label: 'Imię i nazwisko:',
    editable: true,
  },
  agentAddress: {
    label: 'Adres zamieszkania:',
    editable: true,
    type: 'textarea',
  },
  agentPostOffice: {
    label: 'Urząd Pocztowy:',
    editable: true,
  },
  agentPostalCode: {
    label: 'Kod pocztowy:',
    editable: true,
  },
  agentPhoneNumber: {
    label: 'Tel. kontaktowy:',
    editable: true,
  },
};

// const infoDict = {
//   numerKw: {
//     label: 'Numer księgi wieczystej',
//     editable: true,
//   },
// };

const infoDict = {
  wlasciciel: {
    label: 'Właściciel nieruchomości',
    editable: true,
  },
  wspolwlasciciel: {
    label: 'Wspołwłaściciel nieruchomości',
    editable: true,
  },
};

class ZgloszenieUsunieciaDrzew extends React.Component {
  state = {
    DecisionData: {
      AddressCity: null,
      AddressStreet: null,
      wlasciciel: null,
      wspolwlasciciel: null,
      // AddressFlat: null,
      // AddressNumber: null,
      // AddressZipCode: null,
    },
    info: {
      numerKw: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AddressCity: [v.NotNull],
    AddressStreet: [v.NotNull],
    wlasciciel: [v.NotNull],
    // AddressNumber: [v.NotNull],
    // AddressZipCode: [v.NotNull],
    // numerKw: [v.NotNull],
    // agentAdd: [v.NotSelected],
    agentName: [],
    agentAddress: [],
    agentPostOffice: [],
    agentPostalCode: [],
    agentPhoneNumber: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['DecisionData', 'info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
    if (name === 'agentAdd') {
      this.onChangeAgent(e.value);
    }
  }

  onChangeAgent = (value) => {
    if (value === 'TAK') {
      this.validators.agentName = [v.NotNull];
      this.validators.agentAddress = [v.NotNull];
      this.validators.agentPostOffice = [v.NotNull];
      this.validators.agentPostalCode = [v.NotNull];
      this.validators.agentPhoneNumber = [v.NotNull, v.isNumber];
    } else {
      this.validators.agentName = [];
      this.validators.agentAddress = [];
      this.validators.agentPostOffice = [];
      this.validators.agentPostalCode = [];
      this.validators.agentPhoneNumber = [];
    }
  }

  insertTestData = () => {
    this.setState({
      DecisionData: {
        AddressCity: 'Warszawa',
        AddressStreet: 'Koncertowa',
        // AddressFlat: 9,
        // AddressNumber: 6,
        // AddressZipCode: '02-787',
      },
      // info: {
      //   numerKw: '1/23',
      //   agentAdd: 'TAK',
      //   agentName: 'Imie i Nazwisko',
      //   agentAddress: 'Warszawa',
      //   agentPostOffice: 'Warszawa',
      //   agentPostalCode: '02-797',
      //   agentPhoneNumber: '678321985',
      //   agentMotionAddress: 'Adres Testowy',
      // },
    });
  };

  validateAttachmentsContent = () => {
    for (const attachment of this.state.attachments) {
      if (attachment.name.length < 1) return true;
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });

      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          DecisionData: { ...this.state.DecisionData },
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,

        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Adres'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          <div className="help-desc">
          <br></br>
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
              <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.</li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
            treeSelection
          />
        </DecisionContainer>
        <MapToPDF />
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
          </DecisionContainer>
          : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'2. Informacje dodatkowe'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={infoDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        />

        <GrayPanel title={'Informacja dla wnioskodawcy'}>
          <div className="row">
            <div className="col-sm-12">
              <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
              <p>1. Rysunek albo mapka określająca usytuowanie drzewa na nieruchomości</p>
              <p>2. Zgoda współwłaściciela nieruchomości na usunięcie drzew</p>
            </div>
          </div>
        </GrayPanel>

        <RodoContent prefix={this.props.prefix} />

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {(this.props.serviceInfo.user && _.includes(this.props.serviceInfo.user.roles, 'superadmin')) ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZgloszenieUsunieciaDrzew.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
  saveValidators,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZgloszenieUsunieciaDrzew),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZgloszenieUsunieciaDrzew.js